<app-side-menu>
      <div class="staff-table">
        <div class="filters-section">
          <div class="filters-row">
            <div class="filter-group">
              <label for="departmentFilter" class="form-label">Departamento</label>
              <div *ngIf="loadingDepartments" class="loading-statuses">
                <i class="fas fa-spinner fa-spin me-2"></i>
                Carregando...
              </div>
              <select
                *ngIf="!loadingDepartments"
                id="departmentFilter"
                class="form-select"
                [(ngModel)]="listFilters.department"
                (change)="applyListFilters()">
                <option *ngFor="let opt of departmentOptions" [value]="opt.value">{{ opt.label }}</option>
              </select>
            </div>
            <div class="filter-group">
              <label for="statusFilter" class="form-label">Status</label>
              <select
                id="statusFilter"
                class="form-select"
                [(ngModel)]="listFilters.status"
                (change)="applyListFilters()">
                <option *ngFor="let opt of statusOptions" [value]="opt.value">{{ opt.label }}</option>
              </select>
            </div>
            <div class="filter-actions">
              <button type="button" class="btn btn-outline-secondary" (click)="clearListFilters()">
                <i class="fas fa-times me-2"></i>
                Limpar Filtros
              </button>
              <button class="btn btn-success" (click)="openReportModal()">
                <i class="fas fa-file-excel me-2"></i>
                Gerar Relatório Excel
              </button>
              <button
                *ngIf="enableSalaryRaise"
                type="button"
                class="btn btn-primary"
                (click)="openDissidioModal()">
                <i class="fas fa-scale-balanced me-2"></i>
                Aplicar Dissídio (CLT)
              </button>
            </div>
          </div>
        </div>

        <app-table
          [title]="'Funcionários'"
          [data]="staff"
          [columns]="columns"
          [loading]="loading"
          [actions]="actions"
          [useDropdownMenu]="true"
          [showSearch]="true"
          [searchPlaceholder]="'Pesquisar funcionários...'"
          [clickable]="true"
          [disablePagination]="false"
          [itemsPerPage]="pageSize"
          [totalItemsFromBackend]="totalItems"
          [hasNextPageFromBackend]="hasNextPage"
          [hasPreviousPageFromBackend]="hasPreviousPage"
          [currentPageFromBackend]="currentPage"
          [enableSorting]="true"
          [sortableColumns]="['FullName', 'HireDate', 'Id']"
          (searchChange)="onSearchChange($event)"
          (rowClick)="viewStaff($event)"
          (actionClick)="onActionClick($event)"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"
          (sortChange)="onSortChange($event)">
        </app-table>
      </div>

      <!-- Modal de Relatórios -->
      <app-modal
        [isOpen]="showReportModal"
        [title]="'Gerar Relatório Excel'"
        [size]="'lg'"
        [closable]="true"
        (close)="closeReportModal()">
        
        <div class="report-form">
          <!-- Seção de Campos -->
          <div class="report-section mb-4">
            <h5 class="section-title">
              <i class="fas fa-list-check me-2"></i>
              Campos do Relatório
            </h5>
            <p class="text-muted small mb-3">Selecione os campos que deseja incluir no relatório</p>
            
            <div class="field-actions mb-3">
              <button type="button" class="btn btn-sm btn-outline-primary" (click)="selectAllFields()">
                <i class="fas fa-check-double me-1"></i>
                Selecionar Todos
              </button>
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="deselectAllFields()">
                <i class="fas fa-times me-1"></i>
                Desmarcar Todos
              </button>
            </div>

            <div class="fields-grid">
              <div *ngFor="let field of availableFields" class="field-checkbox">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [id]="'field-' + field.key"
                    [checked]="field.checked"
                    (change)="toggleField(field.key)">
                  <label class="form-check-label" [for]="'field-' + field.key">
                    {{ field.label }}
                  </label>
                </div>
              </div>
            </div>
          </div>

          <!-- Seção de Filtros -->
          <div class="report-section mb-4">
            <h5 class="section-title">
              <i class="fas fa-filter me-2"></i>
              Filtros (Opcional)
            </h5>
            <p class="text-muted small mb-3">Aplique filtros para restringir os dados do relatório</p>

            <div class="row g-3">
              <div class="col-md-4">
                <label class="form-label">Departamento</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="reportFilters.department"
                  placeholder="Ex: TI, RH, Vendas...">
                <small class="text-muted">Deixe em branco para incluir todos</small>
              </div>

              <div class="col-md-4">
                <label class="form-label">Status</label>
                <select class="form-control" [(ngModel)]="reportFilters.isActive">
                  <option [value]="null">Todos</option>
                  <option [value]="true">Apenas Ativos</option>
                  <option [value]="false">Apenas Inativos</option>
                </select>
              </div>

              <div class="col-md-4">
                <label class="form-label">Tipo de Contrato</label>
                <select class="form-control" [(ngModel)]="reportFilters.contractType">
                  <option [value]="null">Todos</option>
                  <option value="CLT">CLT</option>
                  <option value="PJ">PJ</option>
                </select>
                <small class="text-muted">Filtrar por tipo de contrato</small>
              </div>
            </div>
          </div>

          <!-- Seção de Opções Adicionais -->
          <div class="report-section mb-4">
            <h5 class="section-title">
              <i class="fas fa-cog me-2"></i>
              Opções Adicionais
            </h5>
            <p class="text-muted small mb-3">Inclua informações adicionais no relatório</p>

            <div class="options-grid">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="includeContacts"
                  [(ngModel)]="reportOptions.includeContacts">
                <label class="form-check-label" for="includeContacts">
                  <i class="fas fa-address-book me-1"></i>
                  Incluir Contatos
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="includeAddresses"
                  [(ngModel)]="reportOptions.includeAddresses">
                <label class="form-check-label" for="includeAddresses">
                  <i class="fas fa-map-marker-alt me-1"></i>
                  Incluir Endereços
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="includeSalary"
                  [(ngModel)]="reportOptions.includeSalary">
                <label class="form-check-label" for="includeSalary">
                  <i class="fas fa-dollar-sign me-1"></i>
                  Incluir Informações Salariais
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="includeBenefits"
                  [(ngModel)]="reportOptions.includeBenefits">
                <label class="form-check-label" for="includeBenefits">
                  <i class="fas fa-gift me-1"></i>
                  Incluir Benefícios
                </label>
              </div>
            </div>
          </div>

          <!-- Mensagem de Erro -->
          <div *ngIf="error" class="alert alert-danger">
            <i class="fas fa-exclamation-triangle me-2"></i>
            {{ error }}
          </div>
        </div>

        <div slot="footer" class="modal-footer-buttons">
          <button
            type="button"
            class="btn btn-secondary"
            (click)="closeReportModal()"
            [disabled]="isGeneratingReport">
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-success"
            (click)="generateReport()"
            [disabled]="isGeneratingReport">
            <span *ngIf="isGeneratingReport" class="spinner-border spinner-border-sm me-2"></span>
            <i *ngIf="!isGeneratingReport" class="fas fa-file-excel me-2"></i>
            {{ isGeneratingReport ? 'Gerando...' : 'Gerar Relatório' }}
          </button>
        </div>
      </app-modal>
      
      <!-- Modal de Aumento Salarial Individual (somente quando enableSalaryRaise = true) -->
      <app-modal
        *ngIf="enableSalaryRaise"
        [isOpen]="showSalaryRaiseModal"
        [title]="'Aumento Salarial'"
        [size]="'md'"
        [closable]="true"
        (close)="closeSalaryRaiseModal()">

        <div class="report-form">
          <div class="report-section mb-3">
            <h5 class="section-title">
              <i class="fas fa-user me-2"></i>
              {{ selectedStaffForRaise?.FullName || 'Funcionário' }}
            </h5>
            <p class="text-muted small mb-0">
              Matrícula: {{ selectedStaffForRaise?.Registration || '-' }} |
              Departamento: {{ selectedStaffForRaise?.Department || '-' }}
            </p>
          </div>

          <!-- Salário atual (fixado) -->
          <div class="report-section mb-3" *ngIf="currentSalary">
            <h5 class="section-title">
              <i class="fas fa-coins me-2"></i>
              Salário Atual
            </h5>
            <div class="row g-3">
              <div class="col-md-4">
                <label class="form-label">Base</label>
                <div class="form-control-plaintext">
                  {{ currentSalary.baseSalary | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-label">Bruto</label>
                <div class="form-control-plaintext">
                  {{ currentSalary.grossSalary | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-label">Líquido</label>
                <div class="form-control-plaintext">
                  {{ currentSalary.netSalary | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
                </div>
              </div>
            </div>
            <div class="row g-3 mt-2">
              <div class="col-md-4">
                <label class="form-label">Moeda</label>
                <div class="form-control-plaintext">
                  {{ currentSalary.currency }}
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-label">Tipo</label>
                <div class="form-control-plaintext">
                  {{ currentSalary.salaryType }}
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-label">Vigente Desde</label>
                <div class="form-control-plaintext">
                  {{ currentSalary.effectiveDate | date:'dd/MM/yyyy' }}
                </div>
              </div>
            </div>
            <div class="row g-3 mt-2" *ngIf="currentSalary.reason || currentSalary.notes">
              <div class="col-md-6" *ngIf="currentSalary.reason">
                <label class="form-label">Motivo do Último Ajuste</label>
                <div class="form-control-plaintext">
                  {{ currentSalary.reason }}
                </div>
              </div>
              <div class="col-md-6" *ngIf="currentSalary.notes">
                <label class="form-label">Observações do Último Ajuste</label>
                <div class="form-control-plaintext">
                  {{ currentSalary.notes }}
                </div>
              </div>
            </div>
          </div>

          <!-- Carregando salário atual -->
          <div class="report-section mb-3">
            <div *ngIf="isLoadingCurrentSalary" class="loading-indicator mb-2">
              <i class="fas fa-spinner fa-spin me-2"></i>
              Carregando salário atual...
            </div>

            <!-- Novo salário (a ser aplicado) -->
            <h5 class="section-title mb-2">
              <i class="fas fa-arrow-up-wide-short me-2"></i>
              Novo Salário
            </h5>
            <div class="row g-3">
              <div class="col-md-4">
                <label class="form-label">Salário Base *</label>
                <input type="number" class="form-control" [(ngModel)]="salaryRaisePayload.baseSalary" />
              </div>
              <div class="col-md-4">
                <label class="form-label">Salário Bruto *</label>
                <input type="number" class="form-control" [(ngModel)]="salaryRaisePayload.grossSalary" />
              </div>
              <div class="col-md-4">
                <label class="form-label">Salário Líquido *</label>
                <input type="number" class="form-control" [(ngModel)]="salaryRaisePayload.netSalary" />
              </div>
            </div>

            <div class="row g-3 mt-2">
              <div class="col-md-4">
                <label class="form-label">Moeda *</label>
                <input type="text" class="form-control" [(ngModel)]="salaryRaisePayload.currency" />
              </div>
              <div class="col-md-4">
                <label class="form-label">Tipo de Salário *</label>
                <input type="text" class="form-control" [(ngModel)]="salaryRaisePayload.salaryType" />
              </div>
              <div class="col-md-4">
                <label class="form-label">Data Efetiva *</label>
                <input type="date" class="form-control" [(ngModel)]="salaryRaisePayload.effectiveDate" />
              </div>
            </div>

            <div class="form-check mt-3">
              <input
                class="form-check-input"
                type="checkbox"
                id="salaryIsActive"
                [(ngModel)]="salaryRaisePayload.isActive" />
              <label class="form-check-label" for="salaryIsActive">
                Registro Ativo
              </label>
            </div>

            <div class="row g-3 mt-3">
              <div class="col-12">
                <label class="form-label">Motivo do Aumento *</label>
                <textarea
                  class="form-control"
                  rows="2"
                  [(ngModel)]="salaryRaisePayload.reason"
                  placeholder="Ex: Promoção para coordenador, ajuste anual, mérito de desempenho">
                </textarea>
              </div>
            </div>

            <div class="row g-3 mt-2">
              <div class="col-12">
                <label class="form-label">Observações (opcional)</label>
                <textarea
                  class="form-control"
                  rows="2"
                  [(ngModel)]="salaryRaisePayload.notes"
                  placeholder="Detalhes adicionais sobre o ajuste salarial, se necessário">
                </textarea>
              </div>
            </div>
          </div>

          <div *ngIf="error" class="alert alert-danger">
            <i class="fas fa-exclamation-triangle me-2"></i>
            {{ error }}
          </div>
        </div>

        <div slot="footer" class="modal-footer-buttons">
          <button
            type="button"
            class="btn btn-secondary"
            (click)="closeSalaryRaiseModal()"
            [disabled]="isSavingSalaryRaise">
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-success"
            (click)="saveSalaryRaise()"
            [disabled]="isSavingSalaryRaise">
            <span *ngIf="isSavingSalaryRaise" class="spinner-border spinner-border-sm me-2"></span>
            <i *ngIf="!isSavingSalaryRaise" class="fas fa-money-bill-trend-up me-2"></i>
            {{ isSavingSalaryRaise ? 'Salvando...' : 'Aplicar Aumento' }}
          </button>
        </div>
      </app-modal>

      <!-- Modal demissão (data de desligamento livre) -->
      <app-modal
        [isOpen]="showTerminateStaffModal"
        [title]="'Registrar demissão'"
        [size]="'md'"
        [closable]="true"
        (close)="closeTerminateStaffModal()">
        <div class="report-form">
          <div class="report-section mb-3" *ngIf="terminateStaffTarget">
            <h5 class="section-title">
              <i class="fas fa-user-minus me-2"></i>
              {{ terminateStaffTarget.FullName }}
            </h5>
            <p class="text-muted small mb-3">
              Matrícula: {{ terminateStaffTarget.Registration || '-' }} ·
              Departamento: {{ terminateStaffTarget.Department || '-' }}
            </p>
            <label class="form-label" for="terminationDatePick">Data de desligamento</label>
            <input
              id="terminationDatePick"
              type="date"
              class="form-control"
              [(ngModel)]="terminationDateInput" />
            <p class="text-muted small mt-2 mb-0">
              Escolha a data em que o desligamento deve ser registrado. O padrão ao abrir é a data de hoje.
            </p>
          </div>
          <div *ngIf="error && showTerminateStaffModal" class="alert alert-danger mb-0">
            <i class="fas fa-exclamation-triangle me-2"></i>{{ error }}
          </div>
        </div>
        <div slot="footer" class="modal-footer-buttons">
          <button type="button" class="btn btn-secondary" (click)="closeTerminateStaffModal()" [disabled]="loading">
            Cancelar
          </button>
          <button type="button" class="btn btn-warning" (click)="confirmTerminateStaff()" [disabled]="loading">
            <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
            <i *ngIf="!loading" class="fas fa-user-slash me-2"></i>
            Confirmar demissão
          </button>
        </div>
      </app-modal>

      <!-- Modal de Dissídio (somente quando enableSalaryRaise = true) -->
      <app-modal
        *ngIf="enableSalaryRaise"
        [isOpen]="showDissidioModal"
        [title]="'Aplicar Dissídio (CLT)'"
        [size]="'lg'"
        [closable]="true"
        (close)="closeDissidioModal()">

        <div class="report-form">
          <div class="report-section mb-3">
            <h5 class="section-title">
              <i class="fas fa-scale-balanced me-2"></i>
              Configuração do Dissídio
            </h5>
          </div>

          <div class="report-section mb-3">
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label">Percentual de Aumento (%) *</label>
                <input
                  type="number"
                  class="form-control"
                  [(ngModel)]="dissidioPayload.percentage"
                  min="0.01"
                  step="0.01" />
              </div>
              <div class="col-md-6">
                <label class="form-label">Data Efetiva *</label>
                <input
                  type="date"
                  class="form-control"
                  [(ngModel)]="dissidioPayload.effectiveDate" />
              </div>
            </div>
          </div>

          <!-- Resultado do dissídio -->
          <div class="report-section mb-3" *ngIf="dissidioResult">
            <h5 class="section-title">
              <i class="fas fa-chart-line me-2"></i>
              Resultado do Dissídio
            </h5>
            <div class="row g-3 mb-2">
              <div class="col-md-3">
                <label class="form-label">Percentual</label>
                <div class="form-control-plaintext">
                  {{ dissidioResult.percentage }} %
                </div>
              </div>
              <div class="col-md-3">
                <label class="form-label">Data Efetiva</label>
                <div class="form-control-plaintext">
                  {{ dissidioResult.effectiveDate | date:'dd/MM/yyyy' }}
                </div>
              </div>
              <div class="col-md-3">
                <label class="form-label">Funcionários (CLT)</label>
                <div class="form-control-plaintext">
                  {{ dissidioResult.updatedEmployees }} / {{ dissidioResult.totalEmployees }}
                </div>
              </div>
              <div class="col-md-3">
                <label class="form-label">Pulados</label>
                <div class="form-control-plaintext">
                  {{ dissidioResult.skippedEmployees }}
                </div>
              </div>
            </div>

            <div class="row g-3">
              <div class="col-md-4">
                <label class="form-label">Total Anterior</label>
                <div class="form-control-plaintext">
                  {{ dissidioResult.totalPreviousSalary | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-label">Total Novo</label>
                <div class="form-control-plaintext">
                  {{ dissidioResult.totalNewSalary | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-label">Acréscimo Total</label>
                <div class="form-control-plaintext">
                  {{ dissidioResult.totalIncrease | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
                </div>
              </div>
            </div>

            <div class="mt-3">
              <label class="form-label">Detalhes por Funcionário</label>
              <div class="table-responsive" style="max-height: 260px; overflow-y: auto;">
                <table class="table table-sm table-striped mb-0">
                  <thead>
                    <tr>
                      <th>Funcionário</th>
                      <th>Matrícula</th>
                      <th>Tipo</th>
                      <th class="text-end">Anterior</th>
                      <th class="text-end">Novo</th>
                      <th class="text-end">Acréscimo</th>
                      <th>Status</th>
                      <th>Motivo</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let d of dissidioResult.details">
                      <td>{{ d.staffName }}</td>
                      <td>{{ d.registration }}</td>
                      <td>{{ d.contractType }}</td>
                      <td class="text-end">
                        {{ d.previousSalary | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
                      </td>
                      <td class="text-end">
                        {{ d.newSalary | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
                      </td>
                      <td class="text-end">
                        {{ d.increase | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
                      </td>
                      <td>
                        <span class="badge" [ngClass]="d.updated ? 'bg-success' : 'bg-warning text-dark'">
                          {{ d.updated ? 'Atualizado' : 'Ignorado' }}
                        </span>
                      </td>
                      <td>{{ d.reason || '-' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div *ngIf="error" class="alert alert-danger">
            <i class="fas fa-exclamation-triangle me-2"></i>
            {{ error }}
          </div>
        </div>

        <div slot="footer" class="modal-footer-buttons">
          <button
            type="button"
            class="btn btn-secondary"
            (click)="closeDissidioModal()"
            [disabled]="isApplyingDissidio">
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-outline-primary"
            (click)="exportDissidioToExcel()"
            [disabled]="!dissidioResult || !dissidioResult.details?.length">
            <i class="fas fa-file-excel me-2"></i>
            Exportar resultado
          </button>
          <button
            type="button"
            class="btn btn-success"
            (click)="applyDissidio()"
            [disabled]="isApplyingDissidio">
            <span *ngIf="isApplyingDissidio" class="spinner-border spinner-border-sm me-2"></span>
            <i *ngIf="!isApplyingDissidio" class="fas fa-scale-balanced me-2"></i>
            {{ isApplyingDissidio ? 'Aplicando...' : 'Aplicar Dissídio' }}
          </button>
        </div>
      </app-modal>
